<ion-card color="white" mode="ios" *ngIf="incidencia.Activo" class="card">
  <ion-card-header mode="md" class="ion-text-center">
    <ion-label
      color="status-icon-enable"
      class="titulo"
      [innerHTML]="incidencia.Titulo | htmlSeguro"
    ></ion-label>
  </ion-card-header>

  <form [formGroup]="formulario" (ngSubmit)="onSubmit()">
    <ion-card-content mode="md">
      <ion-textarea
        autoGrow="false"
        autocapitalize="true"
        debounce="200"
        inputmode="text"
        [minlength]="incidencia.CaracterMinimo"
        [maxlength]="incidencia.CaracterMaximo"
        placeholder="Escribe tu mensaje"
        required
        rows="3"
        spellcheck
        formControlName="comentario"
        fill="outline"
        class="text-area"
        (ionFocus)="ionFocus.emit($event)"
      ></ion-textarea>
      <ion-label class="caracters ion-float-right">
        {{ formulario.get("comentario").value.length }} /
        {{ incidencia.CaracterMaximo }}
      </ion-label>
    </ion-card-content>

    <ion-card-content mode="md" class="ion-text-center">
      <ion-button
        color="tpcta"
        class="boton-send ion-text-uppercase"
        type="submit"
        [disabled]="formulario.invalid || isSpinner"
      >
        <ion-spinner
          name="crescent"
          slot="start"
          *ngIf="isSpinner"
        ></ion-spinner>
        <ion-label>{{ incidencia.Boton }}</ion-label>
      </ion-button>
    </ion-card-content>
  </form>
</ion-card>
